import Table from "components/DataTable/Table";
import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import LeadAdd from "./LeadsAdd";
import LeadAdvanceFormLayout from "./AdvanceSearch/LeadAdvanceFormLayout";

export default function Leads() {
  const user = useSelector((state) => state.user?.userInfo);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // const { advanceSearchParams, setAdvanceSearchParams } = useLead();

  /*   All States
   ********************************************* */

  const [allLeadsData, setAllLeadsData] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [locations, setLocations] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState({
    locationName: "All locations",
  });

  const [showAddModal, setShowAddModal] = useState(false);
  const [advanceSearchModal, setAdvanceSearchModal] = useState(false);

  /*   All Function
   ********************************************* */

  const getAllLeadsData = async (_page, _filterBy, query, location) => {
    try {
      setLoading(true);

      let body = {
        page: _page,
        filterBy: _filterBy,
        query,
      };

      // check for sort and order in searchParams
      let sort = searchParams.get("sort");
      let order = searchParams.get("order");
      if (sort && order) {
        body.sort = sort;
        body.order = order;
      }

      if (location !== "all" && location) {
        body.location = location;
      }

      const { data } = await API.post("/leads", body, {
        headers: authHeader(),
      });

      if (data?.success) {
        setAllLeadsData(data?.result);
        setTotalPages(data?.pages);
      } else {
        dispatch(
          setNotification({
            message: data?.message || "Failed to fetch leads data",
            type: "error",
          })
        );
      }

      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const getAllLocations = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/locations", { headers: authHeader() });
      setLocations(data);
      setLoading(false);
    } catch (err) {
      alert(err.message);
      setLoading(false);
    }
  };

  /*   Table Functions
   ********************************************* */
  const btn1 = () => (
    <div>
      {(user?.permissions?.includes("lead_add") || user?.roles === "admin") && (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Dropdown className="">
            <Dropdown.Toggle
              variant="outline-info"
              className="px-1 bg-primary btn text-dark bg-opacity-10 border border-primary rounded-end rounded-start"
              id="dropdown-basic2"
            >
              {selectedLocation?.locationName
                ? selectedLocation?.locationName
                : "No Location"}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={(e) => {
                  setSelectedLocation({ locationName: "All locations" });
                  updateSearchParams("location", "all");
                }}
              >
                All
              </Dropdown.Item>
              <Dropdown.Item
                onClick={(e) => {
                  setSelectedLocation({ locationName: "No Location" });
                  updateSearchParams("location", "no-location");
                }}
              >
                No Location
              </Dropdown.Item>
              {locations?.map((item) => (
                <Dropdown.Item
                  key={item.id}
                  onClick={(e) => {
                    setSelectedLocation(item);
                    updateSearchParams("location", item?.id);
                  }}
                >
                  {item?.locationName}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <button
            onClick={() => setAdvanceSearchModal(true)}
            type="button"
            className="btn px-2 btn-success"
          >
            Find
          </button>

          <button
            onClick={() => setShowAddModal(true)}
            type="button"
            className="btn px-2 btn-primary"
          >
            Add Lead
          </button>
        </div>
      )}
    </div>
  );

  // Clear Advance Search
  const btnAS = () => (
    <>
      <button
        className="btn btn-danger  ms-1"
        onClick={(e) => {
          setSearchResult(null);
          // setAdvanceSearchParams(null);
        }}
      >
        Clear Advance Search
      </button>
    </>
  );

  const table_head = [
    { name: "L-ID", value: "leadId" },
    { name: "Lead Name", value: "leadName" },
    { name: "Payable Account Name", value: "accountPayableContact" },
    { name: "Payable Account Phone", value: "accountPayablePhone" },
    { name: "Payable Account Email", value: "accountPayableEmail" },
    { name: "location", value: "location?.name" },
    { name: "Actions", value: "Actions" },
  ];

  const table_S_head = [
    "C-ID",
    "Lead Name",
    "Payable Account Name",
    "Payable Account Phone",
    "Payable Account Email",
    "location",
    "Actions",
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-1 align-middle">L-{item?.leadId}</td>
      <td
        className="py-1 align-middle"
        onDoubleClick={() => {
          navigate(`/lead/details/${item?.leadId}?${searchParams.toString()}`);
        }}
      >
        {item?.leadName}
      </td>
      <td className="py-1 align-middle">{item?.accountPayableContact}</td>
      <td className="py-1 align-middle">{item?.accountPayablePhone} </td>
      <td className="py-1 align-middle">{item?.accountPayableEmail}</td>
      <td className="py-1 align-middle">{item?.location?.name}</td>
      <td className="table-action py-1 align-middle">
        <button
          onClick={() => {
            navigate(
              `/lead/details/${item?.leadId}?${searchParams.toString()}`
            );
          }}
          className={`btn btn-sm bg-success text-white mx-2 `}
        >
          Details
        </button>
      </td>
    </tr>
  );

  const updateSearchParams = (key, value) => {
    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }
    setSearchParams(searchParams);
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);

    return params.toString();
  };

  /*   All UseEffect
   ********************************************* */

  useEffect(() => {
    let page = searchParams.get("page");
    if (!page) {
      updateSearchParams("page", 1);
    }
    let _page = page ? page : 1;

    let _filterBy = searchParams.get("filterBy");
    let query = searchParams.get("query");
    let location = searchParams.get("location");

    if (location && locations) {
      if (location === "all" || location === null) {
        setSelectedLocation({ locationName: "All locations" });
      } else {
        let _selectedLocation = locations.find(
          (item) => item.id === parseInt(location)
        );
        setSelectedLocation(_selectedLocation);
      }

      let tid = setTimeout(() => {
        getAllLeadsData(_page, _filterBy, query, location);
      }, 100);
      return () => {
        clearTimeout(tid);
      };
    } else {
      if (user && user?.defaultLocation && locations) {
        let _selectedLocation = locations?.find(
          (item) => item.id === user.defaultLocation
        );
        setSelectedLocation(_selectedLocation);
        updateSearchParams("location", _selectedLocation?.id);
      } else {
        updateSearchParams("location", "all");
        setSelectedLocation("no-default-location");
      }
    }
  }, [searchParams, user, locations]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getAllLocations();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="px-3 py-2" style={{ marginLeft: 260 }}>
      <div>
        <h2 className="mb-2">Leads</h2>
      </div>
      <div className="row">
        {loading && <Spinner />}

        <div className="col-12">
          <div className="d-flex ">
            {/*    Table Card
             ********************************************* */}
            <div className="flex-grow-1 rounded">
              {allLeadsData && !searchResult && (
                <>
                  <div className="horizontal-scrollable d-flex flex-column flex-grow-1">
                    <div className="d-flex justify-content-end align-items-center mb-3">
                      <div className="d-flex justify-content-end align-items-center">
                        <div className="me-1">{btn1()}</div>
                        <SearchComp
                          setLoading={setLoading}
                          apiPath={`/lead/?${getSearchParamsWithoutGivenKey(
                            "query"
                          )}&`}
                        />
                      </div>
                    </div>

                    <TableOnly
                      table_head={table_head}
                      table_body={table_body}
                      table_data={allLeadsData}
                    />

                    <Pagination
                      totalPages={totalPages}
                      apiPath={`/lead/${
                        searchParams.toString()
                          ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                          : "?"
                      }page=`}
                      currPage={parseInt(searchParams.get("page")) || 1}
                    />
                  </div>
                </>
              )}
              {searchResult && (
                <>
                  <div className=" px-3 py-2 pb-2 horizontal-scrollable py-4 d-flex flex-column flex-grow-1">
                    <Table
                      btn1={btnAS}
                      table_head={table_S_head}
                      table_body={table_body}
                      table_data={searchResult}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/*   Add Modal
         ********************************************* */}
        <LeadAdd
          leadsData={allLeadsData}
          showAddModal={showAddModal}
          setShowAddModal={setShowAddModal}
        />

        {/*   Advance Lead Search
         ********************************************* */}
        <Modal
          size="xl"
          contentClassName="bg-transparent"
          show={advanceSearchModal}
          onHide={() => setAdvanceSearchModal(false)}
        >
          <Modal.Body
            className="bg-light custom-shadow-sm p-3"
            style={{ borderRadius: 15 }}
          >
            <LeadAdvanceFormLayout
              showModal={setAdvanceSearchModal}
              setSearchResult={setSearchResult}
            />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
